import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, MenuItem, Menu } from "@mui/material";
import { useTranslation } from "react-i18next";
import { quizQuestionTypes, surveyQuestionTypes } from "../../constants";

const quizTypes = Object.values(quizQuestionTypes);
const surveyTypes = Object.values(surveyQuestionTypes);

const QuestionTypeMenu = ({ onSelect, label, isSurvey }) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = questionType => {
    if (onSelect) {
      onSelect(questionType);
    }
    handleClose();
  };

  const questionTypes = isSurvey ? surveyTypes : quizTypes;

  return (
    <>
      <Button
        aria-controls="new-question-menu"
        aria-haspopup="true"
        color="primary"
        variant="contained"
        onClick={handleClick}
      >
        {label}
      </Button>
      <Menu
        id="new-question-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {questionTypes.map((questionType, index) => (
          <MenuItem
            onClick={() => handleSelect(questionType)}
            value={questionType}
            key={`${questionType}-${index}`}
          >
            {t(`questionBank.questionTypes.${questionType}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

QuestionTypeMenu.propTypes = {
  /**
   * Called when a question type is selected
   */
  onSelect: PropTypes.func,
  label: PropTypes.string
};

export default QuestionTypeMenu;
